/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";
import {
  PharmacyInterview,
  PharmacyInterviewFromJSON,
  PharmacyInterviewFromJSONTyped,
  PharmacyInterviewToJSON,
  PharmacyInterviewCounselingType,
  PharmacyInterviewCounselingTypeFromJSON,
  PharmacyInterviewCounselingTypeFromJSONTyped,
  PharmacyInterviewCounselingTypeToJSON,
  PharmacyOptionalParameter,
  PharmacyOptionalParameterFromJSON,
  PharmacyOptionalParameterFromJSONTyped,
  PharmacyOptionalParameterToJSON,
} from "./";

export const PharmacyChainRegistrableTypename = "PharmacyChainRegistrable" as const;

/**
 *
 * @export
 * @interface PharmacyChainRegistrable
 */
export interface PharmacyChainRegistrable {
  /**
   *
   * @type {number}
   * @memberof PharmacyChainRegistrable
   */
  cutoffDay?: number;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyChainRegistrable
   */
  displayServiceNotification?: boolean;
  /**
   *
   * @type {PharmacyInterview}
   * @memberof PharmacyChainRegistrable
   */
  interviewSheet?: PharmacyInterview;
  /**
   *
   * @type {string}
   * @memberof PharmacyChainRegistrable
   */
  introduceType?: PharmacyChainRegistrableIntroduceTypeEnum;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyChainRegistrable
   */
  isBulkBillingTarget?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyChainRegistrable
   */
  isExceededFollowUpCharLimit?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyChainRegistrable
   */
  isFollowUpOnly?: boolean;
  /**
   *
   * @type {string}
   * @memberof PharmacyChainRegistrable
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof PharmacyChainRegistrable
   */
  note?: string;
  /**
   *
   * @type {Array<PharmacyOptionalParameter>}
   * @memberof PharmacyChainRegistrable
   */
  optionalParameters?: Array<PharmacyOptionalParameter>;
  /**
   *
   * @type {string}
   * @memberof PharmacyChainRegistrable
   */
  privacyPolicyUrl?: string;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyChainRegistrable
   */
  requiredChildWeight?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyChainRegistrable
   */
  requiredDateOfBirth?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyChainRegistrable
   */
  usableChainAnnouncement?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyChainRegistrable
   */
  usableChainFollowUp?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyChainRegistrable
   */
  usableChildWeight?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyChainRegistrable
   */
  usableElapsedTime?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyChainRegistrable
   */
  usableIndividualDelivery?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyChainRegistrable
   */
  usableMccmDigitalPlatformPayment?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyChainRegistrable
   */
  usableOldPricing?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyChainRegistrable
   */
  usableRefill?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyChainRegistrable
   */
  usableReserverType?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyChainRegistrable
   */
  usableUnsupportedList?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyChainRegistrable
   */
  usableWaitingLabel?: boolean;
  /**
   *
   * @type {Array<PharmacyInterviewCounselingType>}
   * @memberof PharmacyChainRegistrable
   */
  usageInterviewCounselingTypes?: Array<PharmacyInterviewCounselingType>;
  /**
   *
   * @type {string}
   * @memberof PharmacyChainRegistrable
   */
  usageInterviewSheet?: PharmacyChainRegistrableUsageInterviewSheetEnum;
  /**
   *
   * @type {string}
   * @memberof PharmacyChainRegistrable
   */
  utmCampaignCode?: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PharmacyChainRegistrable
   */
  readonly __typename?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum PharmacyChainRegistrableIntroduceTypeEnum {
  Web = "web",
  Line = "line",
  App = "app",
} /**
 * @export
 * @enum {string}
 */
export enum PharmacyChainRegistrableUsageInterviewSheetEnum {
  Default = "default",
  Custom = "custom",
  Unused = "unused",
}

export function PharmacyChainRegistrableFromJSON(json: any): PharmacyChainRegistrable {
  return PharmacyChainRegistrableFromJSONTyped(json, false);
}

export function PharmacyChainRegistrableFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PharmacyChainRegistrable {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PharmacyChainRegistrableTypename,

    cutoffDay: !exists(json, "cutoff_day") ? undefined : json["cutoff_day"],
    displayServiceNotification: !exists(json, "display_service_notification")
      ? undefined
      : json["display_service_notification"],
    interviewSheet: !exists(json, "interview_sheet") ? undefined : PharmacyInterviewFromJSON(json["interview_sheet"]),
    introduceType: !exists(json, "introduce_type") ? undefined : json["introduce_type"],
    isBulkBillingTarget: !exists(json, "is_bulk_billing_target") ? undefined : json["is_bulk_billing_target"],
    isExceededFollowUpCharLimit: !exists(json, "is_exceeded_follow_up_char_limit")
      ? undefined
      : json["is_exceeded_follow_up_char_limit"],
    isFollowUpOnly: !exists(json, "is_follow_up_only") ? undefined : json["is_follow_up_only"],
    name: !exists(json, "name") ? undefined : json["name"],
    note: !exists(json, "note") ? undefined : json["note"],
    optionalParameters: !exists(json, "optional_parameters")
      ? undefined
      : (json["optional_parameters"] as Array<any>).map(PharmacyOptionalParameterFromJSON),
    privacyPolicyUrl: !exists(json, "privacy_policy_url") ? undefined : json["privacy_policy_url"],
    requiredChildWeight: !exists(json, "required_child_weight") ? undefined : json["required_child_weight"],
    requiredDateOfBirth: !exists(json, "required_date_of_birth") ? undefined : json["required_date_of_birth"],
    usableChainAnnouncement: !exists(json, "usable_chain_announcement") ? undefined : json["usable_chain_announcement"],
    usableChainFollowUp: !exists(json, "usable_chain_follow_up") ? undefined : json["usable_chain_follow_up"],
    usableChildWeight: !exists(json, "usable_child_weight") ? undefined : json["usable_child_weight"],
    usableElapsedTime: !exists(json, "usable_elapsed_time") ? undefined : json["usable_elapsed_time"],
    usableIndividualDelivery: !exists(json, "usable_individual_delivery")
      ? undefined
      : json["usable_individual_delivery"],
    usableMccmDigitalPlatformPayment: !exists(json, "usable_mccm_digital_platform_payment")
      ? undefined
      : json["usable_mccm_digital_platform_payment"],
    usableOldPricing: !exists(json, "usable_old_pricing") ? undefined : json["usable_old_pricing"],
    usableRefill: !exists(json, "usable_refill") ? undefined : json["usable_refill"],
    usableReserverType: !exists(json, "usable_reserver_type") ? undefined : json["usable_reserver_type"],
    usableUnsupportedList: !exists(json, "usable_unsupported_list") ? undefined : json["usable_unsupported_list"],
    usableWaitingLabel: !exists(json, "usable_waiting_label") ? undefined : json["usable_waiting_label"],
    usageInterviewCounselingTypes: !exists(json, "usage_interview_counseling_types")
      ? undefined
      : (json["usage_interview_counseling_types"] as Array<any>).map(PharmacyInterviewCounselingTypeFromJSON),
    usageInterviewSheet: !exists(json, "usage_interview_sheet") ? undefined : json["usage_interview_sheet"],
    utmCampaignCode: !exists(json, "utm_campaign_code") ? undefined : json["utm_campaign_code"],
  };
}

export function PharmacyChainRegistrableToJSON(object?: PharmacyChainRegistrable | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    cutoff_day: value.cutoffDay,
    display_service_notification: value.displayServiceNotification,
    interview_sheet: PharmacyInterviewToJSON(value.interviewSheet),
    introduce_type: value.introduceType,
    is_bulk_billing_target: value.isBulkBillingTarget,
    is_exceeded_follow_up_char_limit: value.isExceededFollowUpCharLimit,
    is_follow_up_only: value.isFollowUpOnly,
    name: value.name,
    note: value.note,
    optional_parameters:
      value.optionalParameters === undefined
        ? undefined
        : (value.optionalParameters as Array<any>).map(PharmacyOptionalParameterToJSON),
    privacy_policy_url: value.privacyPolicyUrl,
    required_child_weight: value.requiredChildWeight,
    required_date_of_birth: value.requiredDateOfBirth,
    usable_chain_announcement: value.usableChainAnnouncement,
    usable_chain_follow_up: value.usableChainFollowUp,
    usable_child_weight: value.usableChildWeight,
    usable_elapsed_time: value.usableElapsedTime,
    usable_individual_delivery: value.usableIndividualDelivery,
    usable_mccm_digital_platform_payment: value.usableMccmDigitalPlatformPayment,
    usable_old_pricing: value.usableOldPricing,
    usable_refill: value.usableRefill,
    usable_reserver_type: value.usableReserverType,
    usable_unsupported_list: value.usableUnsupportedList,
    usable_waiting_label: value.usableWaitingLabel,
    usage_interview_counseling_types:
      value.usageInterviewCounselingTypes === undefined
        ? undefined
        : (value.usageInterviewCounselingTypes as Array<any>).map(PharmacyInterviewCounselingTypeToJSON),
    usage_interview_sheet: value.usageInterviewSheet,
    utm_campaign_code: value.utmCampaignCode,
  };
}
